export const conexion = {
  production: false,
  server: {
    base_url: 'http://localhost:3330',
  },
  socket: {
    base_url: 'http://localhost:3330',
  },
};
